<template>
  <div class="contact-page column-me" :class="{'mobile-mode': isMobile}">
    <!-- Banner -->
    <div class="banner-section column-me center-all">
      <div class="section-content">
        <div class="banner-item">
          <transition name="banner-fade" mode="out-in">
            <img src="../../assets/img/contact/bg_contact.jpg" class="banner-bg" draggable="false">
          </transition>
          <div class="banner-content" v-if="!isMobile">
            <div class="column-me" v-if="$i18n.locale==='zh-cn'||$i18n.locale==='ja'">
              <img src="../../assets/img/home/home_title1.png" class="w500 objScaleDown" draggable="false">
              <img src="../../assets/img/home/home_title2.png" class="w600 objScaleDown mT20" draggable="false">
            </div>
            <div v-else>
              <img src="../../assets/img/home/home_title11.png" class="h300 objContain" draggable="false">
            </div>
          </div>
          <div class="banner-content font-n" v-if="isMobile">
            <img src="../../assets/img/home/home_title_m.png" class="w220 objContain" draggable="false">
            <div class="font36 font-l mT10" v-if="$i18n.locale==='zh-cn'||$i18n.locale==='ja'">
              悦唯所至 繁复皆<span class="colorOrange">简</span>
            </div>
            <img src="../../assets/img/go.png" class="img70 objFitCover mT40" draggable="false">
          </div>
        </div>
      </div>
    </div>

    <!-- 主要内容区 -->
    <div class="main-content column-me row-center">
      <div class="section-content">
        <!--联系我们-->
        <div class="contact-div row-me animate-section" ref="contactSection">
          <div class="flex1 animate-slide-left" v-if="!isMobile">
            <img src="../../assets/img/contact/img_contact.png" class="wh100Per objFitCover" draggable="false">
          </div>
          <div class="flex1 row-me row-center">
            <div class="flex1">
              <div class="column-me animate-fade-in mL60 mT30" v-if="isMobile">
                <img src="../../assets/img/contact/record.png" class="img45 objContain" draggable="false">
                <div class="font36 font-db colorBlack mT15 font-l">{{ $t('contact.title') }}</div>
              </div>
              <div class="row-me row-center animate-fade-in" v-else>
                <img src="../../assets/img/home/go.png" class="img30 objScaleDown" draggable="false">
                <div class="font24 colorBlack mL10 font-l">{{ $t('contact.title') }}</div>
              </div>
              <img src="../../assets/img/contact/img_contact1.png" class="wh100Per objFitCover mT35" draggable="false"
                   v-if="isMobile">
              <div class="form-div mT70 animate-slide-right">
                <img src="../../assets/img/contact/header.png" class="img-header objScaleDown animate-bounce"
                     draggable="false">
                <div class="row-me mT70 mLR15" style="flex-direction: row !important;">
                  <div class="flex1">
                    <div class="font22 colorBlack font-db">{{ $t('contact.yourName') }}</div>
                    <div class="flex1 mT10">
                      <el-input :placeholder="$t('contact.enterYourName')" style="width: 100%;" clearable
                                class="font20 colorBlack" v-model="formData.name"></el-input>
                    </div>
                  </div>
                  <div class="flex1 mL40">
                    <div class="font22 colorBlack font-db keep-word">{{ $t('contact.yourPhone') }}</div>
                    <div class="flex1 mT10">
                      <el-input :placeholder="$t('contact.enterYourPhone')" style="width: 100%;" clearable
                                class="font20 colorBlack" v-model="formData.phone"></el-input>
                    </div>
                  </div>
                </div>
                <div class="row-me mT50 mLR15">
                  <div class="flex1">
                    <div class="font22 colorBlack font-db">{{ $t('contact.yourCompany') }}</div>
                    <div class="flex1 mT10">
                      <el-input :placeholder="$t('contact.enterYourCompany')" style="width: 100%;" clearable
                                class="font20 colorBlack" v-model="formData.company"></el-input>
                    </div>
                  </div>
                </div>
                <div class="row-me mT50 mLR15">
                  <div class="flex1">
                    <div class="font22 colorBlack font-db">{{ $t('contact.yourMessage') }}</div>
                    <div class="flex1 mT10">
                      <el-input type="textarea" :placeholder="$t('contact.enterYourMessage')" style="width: 100%;"
                                clearable
                                class="font20 colorBlack" rows="5" resize="none" maxlength="130"
                                :show-word-limit="true" v-model="formData.message"></el-input>
                    </div>
                  </div>
                </div>
              </div>
              <div class="w500 column-me row-center mT40">
                <div class="checkbox break-word">
                  <el-checkbox v-model="formData.agree">
                    <span
                        class="font14 colorBlack font-n break-word">{{ $t('contact.privacyAgreement') }}</span>
                  </el-checkbox>
                </div>
                <div class="btn-submit pointer mT20 mB30 font-db" @click="clickSubmit">{{ $t('common.confirmSubmit') }}</div>
              </div>
            </div>
            <img src="../../assets/img/contact/right_line.png" class="w100 objScaleDown mR60" draggable="false">
          </div>
        </div>
        <div class="h10 color-bar" style="background: linear-gradient( 90deg, #F7EEF3 64.84%, #B2C2E3 100%);"
             v-if="!isMobile"></div>
        <!--公司位置-->
        <div class="address-div row-me center-all animate-section" ref="addressSection">
          <div class="address-content row-me row-center">
            <div class="flex2 animate-zoom-in">
              <img src="../../assets/img/contact/img_map.png" class="wh100Per map-top objScaleDown" draggable="false">
            </div>
            <div class="flex1 address-text">
              <div class="fit-content-x column-me flex-end2 animate-slide-right">
                <div class="w100Per row-me row-center">
                  <img src="../../assets/img/contact/address.png" class="img50 objScaleDown" draggable="false"
                       style="margin-left: -5px;">
                </div>
                <div class="font32 colorBlack mT20 fit-content-x pB10 font-db"
                     style="border-bottom: 1px solid #EA8063;">
                  {{ $t('contact.companyName') }}
                </div>
                <div class="font20 colorBlack font-n mT10">{{ $t('contact.address') }}</div>
                <div class="row-me row-center flex-end1 mT40">
                  <div class="row-me center-all img50 border-all-orange pointer animate-share-btn"
                       style="border-right: none; animation-delay: 0.7s;">
                    <img src="../../assets/img/academic/wechat.png" class="img35 objScaleDown share-icon"
                         draggable="false" @click="showWechatQrcode">
                  </div>
                  <div class="row-me center-all img50 border-all-orange pointer animate-share-btn"
                       style="animation-delay: 0.85s;">
                    <img src="../../assets/img/academic/msg.png" class="img35 objScaleDown share-icon"
                         draggable="false" @click="showEmailDialog">
                  </div>
                </div>
              </div>
              <div class="row-me row-center mT80 mL30" v-if="isMobile">
                <div class="btn-p pointer row-me center-all anim-bigger-small" @click="clickHome">
                  <div class="font24 font-n">{{ $t('common.backToHome') }}</div>
                  <img src="../../assets/img/go.png" class="img30 mL10" draggable="false">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 微信二维码弹窗 -->
    <el-dialog v-model="wechatDialogVisible" :width="isMobile ? '80%' : '320px'" center
               custom-class="wechat-qrcode-dialog">
      <template #header>
        <div class="dialog-title" :class="{'dialog-title-mobile': isMobile}">{{ $t('common.wechatQrcode') }}</div>
      </template>
      <div class="qrcode-container" :class="{'qrcode-container-mobile': isMobile}">
        <img src="../../assets/img/code.png" class="qrcode-img" :class="{'qrcode-img-mobile': isMobile}"
             draggable="false">
      </div>
    </el-dialog>
    <!-- 邮箱弹窗 -->
    <el-dialog v-model="emailDialogVisible" :width="isMobile ? '80%' : '320px'" center
               custom-class="wechat-qrcode-dialog">
      <template #header>
        <div class="dialog-title" :class="{'dialog-title-mobile': isMobile}">{{
            $t('common.emailAddress') || '邮箱地址'
          }}
        </div>
      </template>
      <div class="email-container" :class="{'email-container-mobile': isMobile}">
        <div class="email-text" :class="{'email-text-mobile': isMobile}">{{ emailAddress }}</div>
        <div class="copy-btn" :class="{'copy-btn-mobile': isMobile}" @click="copyEmail">{{
            $t('common.copy') || '复制'
          }}
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {deviceState} from "@/utils/device";
import {submitContactForm} from "@/http/api";

export default {
  data() {
    return {
      deviceState,
      wechatDialogVisible: false, // 微信二维码弹窗显示状态
      emailDialogVisible: false, // 邮箱弹窗显示状态
      emailAddress: 'info@bjywmedical.com', // 邮箱地址
      submitting: false, // 提交中状态
      formData: {
        name: '',
        phone: '',
        company: '',
        message: '',
        agree: false
      }
    }
  },
  computed: {
    isMobile() {
      return this.deviceState.isMobile
    }
  },
  created() {
    // 手机端初始化时检查可见区域
    if (this.isMobile) {
      this.$nextTick(() => {
        setTimeout(() => {
          this.checkVisibleSections()
        }, 50)
      })
    }
  },
  mounted() {
    this.initScrollAnimation()
    // 确保页面加载时立即检查可见区域
    this.$nextTick(() => {
      this.checkVisibleSections()
    })
  },
  beforeUnmount() {
    if (this.observer) {
      this.observer.disconnect()
    }
  },
  activated() {
    this.$nextTick(() => {
      this.resetAnimations()
      // 重新检查可见区域
      setTimeout(() => {
        this.checkVisibleSections()
      }, 100)
    })
  },
  methods: {
    clickHome() {
      this.$router.push({
        path: '/home',
        query: {}
      })
    },
    // 重置所有动画
    resetAnimations() {
      const sections = [
        this.$refs.contactSection,
        this.$refs.addressSection
      ]

      sections.forEach(section => {
        if (section) {
          section.classList.remove('animate-in')
        }
      })

      this.$nextTick(() => {
        // 重置 banner 动画
        const bannerContent = document.querySelector('.banner-content')
        if (bannerContent) {
          bannerContent.style.animation = 'none'
          setTimeout(() => {
            bannerContent.style.animation = ''
          }, 10)
        }

        // 重置彩色条动画
        const colorBar = document.querySelector('.color-bar')
        if (colorBar) {
          colorBar.style.animation = 'none'
          setTimeout(() => {
            colorBar.style.animation = ''
          }, 10)
        }

        // 重置所有需要动画的元素
        const animatedElements = document.querySelectorAll('.animate-fade-in, .animate-bounce')
        animatedElements.forEach(el => {
          el.style.animation = 'none'
          setTimeout(() => {
            el.style.animation = ''
          }, 10)
        })
      })
    },
    // 初始化滚动动画
    initScrollAnimation() {
      const options = {
        threshold: 0.15,
        rootMargin: '0px 0px -50px 0px'
      }

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-in')
          }
        })
      }, options)

      const sections = [
        this.$refs.contactSection,
        this.$refs.addressSection
      ]

      sections.forEach(section => {
        if (section) {
          this.observer.observe(section)
        }
      })
    },
    // 检查当前视口中可见的区块，立即触发它们的动画
    checkVisibleSections() {
      const sections = [
        this.$refs.contactSection,
        this.$refs.addressSection
      ]

      // 手机端直接触发所有动画，确保内容可见
      if (this.isMobile) {
        sections.forEach(section => {
          if (section) {
            section.classList.add('animate-in')
          }
        })
        return
      }

      sections.forEach(section => {
        if (section) {
          const rect = section.getBoundingClientRect()
          const windowHeight = window.innerHeight || document.documentElement.clientHeight
          const threshold = 0.85

          if (rect.top < windowHeight * threshold && rect.bottom > 0) {
            section.classList.add('animate-in')
          }
        }
      })
    },
    async clickSubmit() {
      if (this.$method.isEmpty(this.formData.name)) {
        this.$message.warning(this.$t('contact.validation.nameRequired'))
        return
      }
      if (this.$method.isEmpty(this.formData.phone)) {
        this.$message.warning(this.$t('contact.validation.phoneRequired'))
        return
      }
      if (this.$method.isEmpty(this.formData.company)) {
        this.$message.warning(this.$t('contact.validation.companyRequired'))
        return
      }
      if (this.$method.isEmpty(this.formData.message)) {
        this.$message.warning(this.$t('contact.validation.messageRequired'))
        return
      }
      if (this.$method.isEmpty(this.formData.agree) || !this.formData.agree) {
        this.$message.warning(this.$t('contact.validation.agreeRequired'))
        return
      }
      // 防止重复提交
      if (this.submitting) return
      this.submitting = true
      try {
        const res = await submitContactForm({
          name: this.formData.name,
          phone: this.formData.phone,
          company: this.formData.company,
          message: this.formData.message
        })
        if (res && res.code === 200) {
          this.$message.success(this.$t('contact.submitSuccess'))
          this.formData = {
            name: '',
            phone: '',
            company: '',
            message: '',
            agree: false
          }
        } else {
          this.$message.error(res?.msg || '提交失败，请稍后重试')
        }
      } catch (error) {
        console.error('提交联系表单失败:', error)
        this.$message.error('提交失败，请稍后重试')
      } finally {
        this.submitting = false
      }
    },
    // 显示微信二维码弹窗
    showWechatQrcode() {
      this.wechatDialogVisible = true
    },
    // 显示邮箱弹窗
    showEmailDialog() {
      this.emailDialogVisible = true
    },
    // 复制邮箱地址
    copyEmail() {
      const successMsg = this.$t('common.copySuccess') || '复制成功'
      const text = this.emailAddress
      const textarea = document.createElement('textarea')
      textarea.value = text
      textarea.style.position = 'fixed'
      textarea.style.left = '-9999px'
      textarea.style.top = '-9999px'
      document.body.appendChild(textarea)
      textarea.focus()
      textarea.select()
      try {
        const successful = document.execCommand('copy')
        if (successful) {
          this.$message.success(successMsg)
        } else {
          navigator.clipboard.writeText(text).then(() => {
            this.$message.success(successMsg)
          }).catch(() => {
            this.$message.error('复制失败')
          })
        }
      } catch (err) {
        navigator.clipboard.writeText(text).then(() => {
          this.$message.success(successMsg)
        }).catch(() => {
          this.$message.error('复制失败')
        })
      }
      document.body.removeChild(textarea)
    },
  },
  watch: {
    $route: {
      handler(to, from) {
        if (to.path === '/contact' && from && from.path !== '/contact') {
          setTimeout(() => {
            this.resetAnimations()
            window.scrollTo({top: 0, behavior: 'smooth'})
          }, 50)
        }
      },
      immediate: false
    }
  }
}
</script>

<style lang="scss" scoped>
.contact-page {
  width: 100%;
  scroll-behavior: smooth;
  overflow: hidden;

  .btn-submit {
    padding: 0 15px;
    line-height: 43px;
    border-radius: 21px 21px 21px 21px;
    border: 1px solid #AAABC4;
    font-size: 22px;
    color: #2C2B30;
    text-align: center;
    transition: all 0.3s ease;

    &:hover {
      background: #EA8063;
      color: #FFFFFF;
      border-color: #EA8063;
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(234, 128, 99, 0.3);
    }
  }

  .address-div {
    width: 100%;
    height: 900px;

    .address-content {
      width: 90%;
      height: 90%;
      background-image: url("../../assets/img/contact/bg_map.png");
      background-repeat: no-repeat;
      background-size: 88% 100%;

      .map-top {
        width: 85% !important;
        object-fit: contain;
        margin-left: 50px;
      }
    }
  }
}

// Banner 进入动画
.banner-section {
  .banner-content {
    animation: fadeInUp 1.2s ease-out 0.3s both;
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(60px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

// 滚动触发动画
.animate-section {
  opacity: 0;
  transform: translateY(50px);
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;

  &.animate-in {
    opacity: 1;
    transform: translateY(0);
  }
}

// 淡入动画
.animate-fade-in {
  opacity: 0;
  animation: fadeIn 1s ease-out 0.3s both;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

// 左侧滑入动画
.animate-slide-left {
  opacity: 0;
  transform: translateX(-60px);
  transition: all 0.8s ease-out 0.2s;
}

// 右侧滑入动画
.animate-slide-right {
  opacity: 0;
  transform: translateX(60px);
  transition: all 0.8s ease-out 0.4s;
}

// 缩放进入动画
.animate-zoom-in {
  opacity: 0;
  transform: scale(0.9);
  transition: all 0.8s ease-out 0.3s;
}

// 当父元素有 animate-in 类时触发子元素动画
.animate-section.animate-in {
  .animate-slide-left,
  .animate-slide-right,
  .animate-zoom-in {
    opacity: 1;
    transform: translateX(0) scale(1);
  }

  .animate-slide-left {
    transform: translateX(0);
  }

  .animate-slide-right {
    transform: translateX(0);
  }

  .animate-zoom-in {
    transform: scale(1);
  }
}

// 弹跳动画
.animate-bounce {
  animation: bounceIn 1.2s ease-out 0.6s both;
}

@keyframes bounceIn {
  0% {
    opacity: 0;
    transform: translateX(-50%) scale(0.3);
  }
  50% {
    opacity: 1;
    transform: translateX(-50%) scale(1.1);
  }
  70% {
    transform: translateX(-50%) scale(0.9);
  }
  100% {
    opacity: 1;
    transform: translateX(-50%) scale(1);
  }
}

// 彩色条展开动画
.color-bar {
  opacity: 0;
  transform: scaleX(0);
  transform-origin: left;
  animation: barExpand 0.8s ease-out 0.5s forwards;
}

@keyframes barExpand {
  to {
    opacity: 1;
    transform: scaleX(1);
  }
}

// 主要内容区
.main-content {
  background: #FFFFFF;

  .contact-div {
    width: 100%;
    height: 1020px;

    .form-div {
      width: 505px;
      height: 535px;
      border: 1px solid #AAABC4;
      position: relative;

      .img-header {
        width: 100px;
        height: 100px;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: -55px;
        background: #FFFFFF;
        border: 20px solid #FFFFFF;
      }
    }
  }
}

// 输入框悬停效果
:deep(.el-input__wrapper) {
  transition: all 0.3s ease;

  &:hover {
    border-color: #EA8063 !important;
    box-shadow: 0 0 0 1px #EA8063 inset !important;
  }
}

:deep(.el-textarea__inner) {
  transition: all 0.3s ease;

  &:hover {
    border-color: #EA8063 !important;
  }

  &:focus {
    border-color: #EA8063 !important;
  }
}

// 社交图标悬停效果
.animate-share-btn {
  opacity: 0;
  transform: scale(0);
  animation: scaleIn 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;
  position: relative;
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 0;
    height: 0;
    border-radius: 50%;
    background: rgba(234, 128, 99, 0.3);
    transform: translate(-50%, -50%);
    transition: width 0.6s, height 0.6s;
  }

  &:hover {
    opacity: 1 !important;
    background: #EA8063 !important;
    border-color: #EA8063 !important;
    transform: scale(1) !important;
    box-shadow: 0 8px 20px rgba(234, 128, 99, 0.4) !important;

    &::before {
      width: 200%;
      height: 200%;
    }

    .share-icon {
      transform: scale(1.1);
      filter: brightness(0) invert(1);
    }
  }

  &:active {
    opacity: 1 !important;
    transform: translateY(-3px) scale(1.05) !important;
  }

  .share-icon {
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
    z-index: 1;
  }
}

@keyframes scaleIn {
  to {
    opacity: 1;
    transform: scale(1);
  }
}

// 微信二维码弹窗样式
.dialog-title {
  font-size: 18px;
  font-weight: bold;
  color: #FFFFFF;
  text-align: center;
  letter-spacing: 2px;

  &.dialog-title-mobile {
    font-size: 25px;
  }
}

.qrcode-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;

  &.qrcode-container-mobile {
    padding: 30px 20px 40px;
  }
}

.qrcode-img {
  width: 200px;
  height: 200px;
  object-fit: contain;

  &.qrcode-img-mobile {
    width: 100%;
    max-width: 400px;
    height: auto;
    aspect-ratio: 1;
    // 允许长按保存图片
    -webkit-touch-callout: default;
    -webkit-user-select: auto;
    user-select: auto;
  }
}

// 邮箱弹窗样式
.email-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;

  &.email-container-mobile {
    padding: 30px 20px 40px;
  }
}

.email-text {
  font-size: 16px;
  color: #2C2B30;
  text-align: center;
  word-break: break-all;
  padding: 20px;
  background: #F5F5F5;
  border-radius: 8px;
  width: 100%;
  box-sizing: border-box;

  &.email-text-mobile {
    font-size: 24px;
    padding: 25px;
  }
}

.copy-btn {
  margin-top: 20px;
  padding: 10px 40px;
  font-size: 16px;
  color: #FFFFFF;
  background: #013D5C;
  border-radius: 25px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: #025A87;
  }

  &:active {
    background: #012A40;
  }

  &.copy-btn-mobile {
    font-size: 24px;
    padding: 15px 60px;
    margin-top: 30px;
  }
}


// ==================== 手机端适配样式 ====================
.contact-page.mobile-mode {
  // Banner 适配 - 与首页保持一致
  .banner-section {
    .section-content {
      width: 100% !important;
      padding: 0 !important;
    }

    .banner-item {
      position: relative;
      width: 100%;
      height: 1020px;
      aspect-ratio: 16 / 9;
      overflow: hidden;
      background: #f6f6f6;

      .banner-bg {
        position: absolute;
        top: inherit;
        left: inherit;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 70%;
        object-fit: cover;
      }

      .banner-content {
        position: absolute;
        top: 25%;
        left: 8%;
        display: flex;
        flex-direction: column;
        font-size: 87px;
        line-height: 80px;
        color: #454F5E;
      }
    }
  }

  // 主内容区适配
  .main-content {
    .section-content {
      width: 100% !important;
      box-sizing: border-box;
    }

    // 联系表单区域
    .contact-div {
      flex-direction: column !important;
      height: auto !important;
      padding: 20px 0;

      // 左侧图片容器 - 手机端不渲染，但保留样式以防万一
      // 注意：不要使用 :first-child/:last-child，因为 v-if 会改变DOM结构
      .flex1.animate-slide-left {
        width: 100%;
        height: 200px;
        margin-bottom: 20px;
      }

      // 右侧表单区域 - 使用精确选择器 .flex1.row-me
      .flex1.row-me {
        flex-direction: column !important;
        padding: 0;
        width: 100%;
        height: auto !important;

        // 表单内容容器
        & > .flex1 {
          width: 100%;
          height: auto;
          overflow: visible;
        }

        // 隐藏右侧装饰线
        .w100 {
          display: none;
        }

        .mT40 {
          margin-top: 20px;
        }

        .w500 {
          width: 100% !important;

          .checkbox {
            margin: 0 60px;
          }

          .font14 {
            white-space: break-spaces;
            font-size: 18px !important;
          }

          .btn-submit {
            padding: 0 15px;
            line-height: 50px;
            font-size: 25px !important;
            margin-top: 35px !important;
            border-radius: 50px;
            background: #EDEDF1;
            border: none;
            font-family: font-db, serif;
          }
        }
      }

      // 标题适配
      .row-me.row-center.animate-fade-in {
        margin-left: 60px;
        margin-top: 20px;

        .img30 {
          width: 40px !important;
          height: 40px !important;
          object-fit: cover !important;
        }

        .font24 {
          font-size: 36px !important;
          font-family: font-db, sans-serif;
        }
      }

      // 表单容器
      .form-div {
        height: auto !important;
        padding: 60px 15px 25px !important;
        margin-left: auto !important;
        margin-right: auto !important;
        margin-top: -50px !important;
        margin-bottom: 0 !important;
        width: 85%;
        position: relative !important;

        .img-header {
          width: 90px !important;
          height: 90px !important;
          top: -50px !important;
          border-width: 15px !important;
          object-fit: contain;
        }

        // 表单行
        .row-me.mT70, .row-me.mT50 {
          flex-direction: column !important;
          margin-top: 20px !important;
          margin-left: 0 !important;
          margin-right: 0 !important;

          .flex1 {
            width: 100% !important;
            margin-bottom: 15px;

            .font22 {
              font-size: 28px !important;
            }

            .font20 {
              font-size: 24px !important;
            }
          }

          :deep(.el-input__inner), :deep(.el-textarea__inner) {
            font-size: 24px !important;
          }

          :deep(.el-input__wrapper) {
            padding: 15px 15px !important;
            border-radius: 10px !important;
          }
        }
      }
    }

    // 颜色条
    .color-bar {
      height: 6px !important;
    }

    // 公司位置区域
    .address-div {
      height: auto !important;

      .address-content {
        flex-direction: column !important;
        align-items: flex-end !important;
        width: 100% !important;
        height: auto !important;
        background-size: cover;
        background-position: center;
        background-image: url("../../assets/img/contact/bg_map1.png") !important;
        padding-bottom: 50px;
        margin-top: 150px;

        .map-top {
          margin-top: -160px;
          width: 100% !important;
          object-fit: contain;
          margin-left: 0;
        }

        img {
          object-fit: contain;
        }

        .flex2 {
          width: 100% !important;
        }

        .address-text {
          margin-top: 50px;
          padding-right: 60px;
          max-width: 70%;

          .img50 {
            width: 60px !important;
            height: 60px !important;

            img {
              width: 30px !important;
              height: 30px !important;
            }
          }
        }
      }
    }
  }

  .btn-p {
    margin-top: 30px !important;
    padding: 0 20px;
    height: 50px;
    line-height: 50px;
    background: #EDEDF1;
    border-radius: 30px;

    .font24 {
      font-size: 24px !important;
    }

    .img30 {
      width: 30px !important;
      height: 30px !important;
      margin-left: 8px !important;
      object-fit: cover;
    }
  }
}
</style>
